(function () {
  if (!window.location.pathname.includes('/pages/treats-with-a-purpose')) return;
  var SELECTORS = ['#form-container-ref', 'section[class*="_inline_1q1d2_"]'];
  function hide() {
    SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('opacity', '0', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
        el.style.setProperty('height', '0', 'important');
        el.style.setProperty('overflow', 'hidden', 'important');
        el.style.setProperty('position', 'absolute', 'important');
      });
    });
  }
  hide();
  var obs = new MutationObserver(hide);
  obs.observe(document.documentElement, { childList: true, subtree: true });
  setInterval(hide, 300);
})();
